import React from 'react';
import { Card } from 'antd';

export interface FormSectionProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  children: React.ReactNode;
  /** 右上角可放 action（例如「+ 新增」按鈕） */
  extra?: React.ReactNode;
}

/**
 * 分區卡片 — 每 4-7 個相關欄位一組，title 用 h3 + 一句 description。
 * 依無障礙規範使用 <section aria-labelledby>。
 */
export const FormSection: React.FC<FormSectionProps> = ({ title, description, children, extra }) => {
  const titleId = React.useId();
  return (
    <Card
      size="small"
      styles={{ body: { padding: '16px 20px' } }}
      style={{ marginBottom: 16 }}
      title={
        <div>
          <h3 id={titleId} style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>
            {title}
          </h3>
          {description && (
            <div style={{ marginTop: 4, fontSize: 12, color: 'rgba(0,0,0,0.55)', fontWeight: 400 }}>
              {description}
            </div>
          )}
        </div>
      }
      extra={extra}
    >
      <section aria-labelledby={titleId}>{children}</section>
    </Card>
  );
};
